export const getIsBoardEmpty = sortedColumns => sortedColumns.every(columnData => {
  return columnData.cards.length === 0;
});
export const getIsPipelineLoading = sortedColumns => sortedColumns.every(columnData => {
  return columnData.isLoadingNewData;
});
export const isColumn = x => {
  return x !== undefined;
};